import {atom} from "recoil";

export const userState = atom({
  key: 'userInfo',
  default: {
    'email': '',
  },
});

export const snackbarState = atom({
  key: 'snackbarState',
  default: {'open': false, 'message': ''},
});
